import { useEffect, useState } from "react";
import styles from "../css/media.module.css";
const StarAttractionCard = ({ starAttractionItem }) => {
  // console.log(starAttractionItem);
  return (
    <li>
      <div>
        <code></code>
        <text>
          <h2>{starAttractionItem.title}</h2>
          <img
            src={starAttractionItem.contentLink}
            width="200"
            height="130"
            alt="Placeholder"
          />
          <p>{starAttractionItem.desc.slice(0, 100)}...</p>
          <a href={starAttractionItem.insta} style={{ background: "purple" }}>
            View More
          </a>
        </text>
      </div>
    </li>
  );
};

export default StarAttractionCard;
